import {
  BorderBeam as BaseBorderBeam,
  type BorderBeamProps,
} from "@/components/ui/border-beam"

export function BorderBeam(props: BorderBeamProps) {
  return (
    <BaseBorderBeam
      colorFrom="var(--warning)"
      colorTo="var(--chart-4)"
      {...props}
    />
  )
}

export type { BorderBeamProps }
